<template>
  <div class="out_wrap">
    <el-tabs v-model="activeTab" @tab-click="handleClick">
      <el-tab-pane label="发票信息" name="info">
        <info-component ref="info" />
      </el-tab-pane>
      <el-tab-pane label="收票地址管理" name="address">
        <address-component ref="address" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import InfoComponent from './components/info'
import AddressComponent from './components/address'
export default {
  components: {
    InfoComponent,
    AddressComponent
  },
  data() {
    return {
      activeTab: 'info'
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.info.query()
    })
  },
  methods: {
    handleClick(tab, e) {
      if (tab.name === 'info') {
        this.$refs.info.query()
      } else if (tab.name === 'address') {
        this.$refs.address.query()
      }
    }
  }
}
</script>

<style>

</style>
